import { flatten } from 'ramda';
import { PAYMENT_SERVICE_IDS } from '../../constants';

export const getKeyByServiceId = (activeServiceId?: number) => {
  const [key] = flatten(
    Object.entries(PAYMENT_SERVICE_IDS).filter(([, ids]) => {
      return (
        activeServiceId === ids ||
        (Array.isArray(ids) && ids.includes(activeServiceId as number))
      );
    })
  ) as [keyof typeof PAYMENT_SERVICE_IDS];

  return key;
};
